var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBoiler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 41,
    viewBox: "0 0 26 41",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2758 32.7243H16.5862C16.0913 32.7243 15.6896 32.3226 15.6896 31.8277C15.6896 31.3328 16.0913 30.9312 16.5862 30.9312H19.2758C19.7707 30.9312 20.1724 31.3328 20.1724 31.8277C20.1724 32.3226 19.7707 32.7243 19.2758 32.7243Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2758 30.0348H16.5862C16.0913 30.0348 15.6896 29.6331 15.6896 29.1383C15.6896 28.6434 16.0913 28.2417 16.5862 28.2417H19.2758C19.7707 28.2417 20.1724 28.6434 20.1724 29.1383C20.1724 29.6331 19.7707 30.0348 19.2758 30.0348Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4147 0H3.58531C1.61334 0 0 1.61334 0 3.58531V33.1733C0 35.1448 1.61334 36.7586 3.58531 36.7586H9.86207V39.4483C9.86207 39.9432 10.2637 40.3448 10.7586 40.3448C11.2535 40.3448 11.6552 39.9432 11.6552 39.4483V36.7586H14.3448V39.4483C14.3448 39.9432 14.7465 40.3448 15.2414 40.3448C15.7363 40.3448 16.1379 39.9432 16.1379 39.4483V36.7586H22.4147C24.3862 36.7586 26 35.1448 26 33.1733V3.58531C26 1.61334 24.3862 0 22.4147 0ZM24.2069 33.1733C24.2069 34.1613 23.4027 34.9655 22.4147 34.9655H3.58531C2.59686 34.9655 1.7931 34.1613 1.7931 33.1733V26H24.2069V33.1733ZM24.2069 24.2069H1.7931V3.58531C1.7931 2.59686 2.59686 1.7931 3.58531 1.7931H22.4147C23.4027 1.7931 24.2069 2.59686 24.2069 3.58531V24.2069Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1034 33.1723H6.72413C6.22923 33.1723 5.82758 32.7706 5.82758 32.2757V28.6895C5.82758 28.1946 6.22923 27.793 6.72413 27.793H12.1034C12.5983 27.793 13 28.1946 13 28.6895V32.2757C13 32.7706 12.5983 33.1723 12.1034 33.1723ZM7.62068 31.3792H11.2069V29.5861H7.62068V31.3792Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87257 11.4601C7.5101 11.7481 7.00264 12.1801 6.64017 12.9721C5.77024 14.9162 6.71266 16.9323 6.85765 17.1483C7.87257 19.1644 10.1924 20.1724 12.3672 20.1724C13.1647 20.1724 13.9621 20.0284 14.687 19.7404C16.4269 19.0924 17.3693 17.7963 17.7318 17.3643C18.6017 16.2123 19.1092 14.9162 19.2542 13.4762C19.3267 12.7561 19.2542 11.2441 18.4568 9.66001C18.0218 8.79598 17.3693 8.00395 16.6444 7.35592L15.3395 6.27588L14.9045 7.93194C14.7595 8.50797 14.5421 9.08399 14.2521 9.58801C13.8896 9.01199 13.5271 8.36396 13.0922 7.93194C11.7148 6.41988 9.39496 6.49189 8.09006 6.63589L6.35019 6.9239L7.43761 8.36396C8.23504 9.444 8.59752 10.38 8.38003 10.8841C8.30754 11.1721 8.16255 11.2441 7.87257 11.4601ZM8.67001 13.9082C8.815 13.5482 9.03248 13.4042 9.32246 13.1882C9.68493 12.9001 10.1199 12.4681 10.4099 11.7481C10.6999 10.8841 10.6999 9.94802 10.1924 8.86798C10.7723 8.93998 11.2798 9.15599 11.5698 9.444C11.7148 9.66001 12.0773 10.092 12.6572 11.1001C12.8747 11.4601 13.0197 11.8921 13.2372 12.2521L13.9621 13.9082L15.122 12.5401C15.412 12.1801 15.702 11.7481 15.992 11.3881C16.2094 11.1001 16.3544 10.7401 16.4994 10.38C16.5719 10.524 16.6444 10.5961 16.7169 10.7401C17.2969 11.8201 17.2968 12.9001 17.2968 13.4042C17.2244 14.8442 16.4994 15.7803 16.2094 16.1403C15.9195 16.5003 15.267 17.4363 14.1071 17.7963C12.3672 18.4444 9.75743 17.8683 8.95999 16.2123C8.815 16.2123 8.16255 14.9162 8.67001 13.9082Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.6896,
    y1: 30.9312,
    x2: 16.9263,
    y2: 34.0227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.6896,
    y1: 28.2417,
    x2: 16.9263,
    y2: 31.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0,
    y1: 0,
    x2: 36.7411,
    y2: 23.6776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 5.82758,
    y1: 27.793,
    x2: 10.9917,
    y2: 34.6785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 6.27588,
    y1: 6.27588,
    x2: 20.1416,
    y2: 19.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoiler);
export default __webpack_public_path__ + "static/media/icon-boiler.c80e395f301ce08abfae2eddf5905a27.svg";
export { ForwardRef as ReactComponent };